"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useHandleAddToBasket = void 0;
const react_1 = require("react");
const react_redux_1 = require("react-redux");
const selectors_1 = require("../AccountProvider/selectors");
const utils_1 = require("../ConfigProvider/utils");
const types_1 = require("../ConfigProvider/types");
const slice_1 = require("../GuestBasketProvider/slice");
const slice_2 = require("./slice");
const constants_1 = require("./constants");
const useHandleAddToBasket = () => {
    const dispatch = (0, react_redux_1.useDispatch)();
    const accountId = (0, react_redux_1.useSelector)(selectors_1.selectAccountId);
    const isGuestBasketEnabled = (0, utils_1.useFeatureFlag)(types_1.EFeatureFlags.GUEST_BASKET_ENABLED);
    return (0, react_1.useCallback)(({ eventId, eventStatus, eventProbability, callback, }) => {
        const isAddBasket = eventProbability &&
            constants_1.activeEventStatus.includes(eventStatus) &&
            constants_1.activeProbabilityStatus.includes(eventProbability.tradingStatus);
        if (isAddBasket) {
            if (accountId) {
                dispatch(slice_2.basketProviderActions.addOutcomeToBasket({
                    eventProbability,
                    eventId,
                }));
            }
            else if (isGuestBasketEnabled) {
                dispatch(slice_1.guestBasketProviderActions.addToGuestBasket({
                    eventId,
                    eventStatus,
                    eventProbability,
                }));
            }
        }
        if (callback) {
            callback();
        }
    }, [accountId, dispatch, isGuestBasketEnabled]);
};
exports.useHandleAddToBasket = useHandleAddToBasket;
//# sourceMappingURL=add-to-basket.js.map